/**
 * Institutional Client Profile Form Data
 * Based on SecondLane Securities LLC - New Institutional Client Profile Form
 */
export interface InstitutionalProfileFormData {
  // Institution Information
  institution_name: string
  institution_type: string
  tax_id_ein: string
  registration_status: string

  // Incorporation facts (drive the Sumsub KYB level server-side).
  // 🔴 `legal_form` is one of exactly seven values (see LEGAL_FORMS in
  // institutionalFields.ts). The backend resolves the verification level from
  // it and REFUSES writes that would change it while a verification is active
  // (409 `legal_form_locked`). `institution_type` above is an INDUSTRY
  // classification and has nothing to do with level selection.
  legal_form: string
  incorporation_country: string
  incorporation_state: string
  registration_number: string
  incorporated_on: string
  
  // Contact Information
  primary_contact_name: string
  primary_contact_title: string
  primary_contact_email: string
  primary_contact_phone: string
  mailing_address_line1: string
  mailing_address_line2: string
  mailing_city: string
  mailing_state: string
  mailing_postal_code: string
  mailing_country: string
  
  // Regulatory Information
  sec_registration_number: string
  state_registration: string
  finra_crd_number: string
  other_regulatory_identifiers: string
  
  // Account Information
  investment_objectives: string
  risk_tolerance: string
  assets_under_management: string
  
  // Compliance & Certifications
  accredited_investor_status: boolean
  qualified_institutional_buyer: boolean
  institutional_customer: boolean
  other_certifications: string
  
  // Additional Information
  number_of_employees: string
  description_of_business: string
  investment_experience: string
  previous_broker_dealer_relationships: string
  
  // Banking Information
  bank_name: string
  bank_account_number: string
  bank_routing_number: string
  bank_address: string
  
  // Compliance Attestations
  anti_money_laundering_compliance: boolean
  know_your_customer_compliance: boolean
  sanctions_compliance: boolean
  data_protection_compliance: boolean
  
  // Additional Fields
  marketing_consent: boolean
  terms_accepted: boolean
}

export const getDefaultInstitutionalProfileFormData = (): InstitutionalProfileFormData => ({
  institution_name: '',
  institution_type: '',
  tax_id_ein: '',
  registration_status: '',
  legal_form: '',
  incorporation_country: '',
  incorporation_state: '',
  registration_number: '',
  incorporated_on: '',
  primary_contact_name: '',
  primary_contact_title: '',
  primary_contact_email: '',
  primary_contact_phone: '',
  mailing_address_line1: '',
  mailing_address_line2: '',
  mailing_city: '',
  mailing_state: '',
  mailing_postal_code: '',
  mailing_country: '',
  sec_registration_number: '',
  state_registration: '',
  finra_crd_number: '',
  other_regulatory_identifiers: '',
  investment_objectives: '',
  risk_tolerance: '',
  assets_under_management: '',
  accredited_investor_status: false,
  qualified_institutional_buyer: false,
  institutional_customer: false,
  other_certifications: '',
  number_of_employees: '',
  description_of_business: '',
  investment_experience: '',
  previous_broker_dealer_relationships: '',
  bank_name: '',
  bank_account_number: '',
  bank_routing_number: '',
  bank_address: '',
  anti_money_laundering_compliance: false,
  know_your_customer_compliance: false,
  sanctions_compliance: false,
  data_protection_compliance: false,
  marketing_consent: false,
  terms_accepted: false,
})
